import { useTranslation } from "react-i18next";
import ArticlesIcon from "src/images/Icons/newIcons/exam/options/article.svg";

import DefaultOptions from "./DefaultOption";

export default function Article({ settings, details, actions, dispatch }) {
	const { t } = useTranslation();

	return (
		<DefaultOptions
			keysToPress={["Meta + a"]}
			optionKey="article"
			Icon={<ArticlesIcon className="icon-normal" />}
			dispatch={dispatch}
			text={t("exam.article")}
			action={actions.toggleSettings}
			settings={settings}
			disabled={!details.visibility?.articles}
			badgeOptions={{
				badgeContent: details.articlesCount,
				color: "secondary",
			}}
		/>
	);
}
